import script from "./errorPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./errorPanel.vue?vue&type=script&lang=ts&setup=true"

import "./errorPanel.vue?vue&type=style&index=0&id=9690fdda&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9690fdda"]])

export default __exports__